import request from '@utils/request'
import { ReturnType } from './types'

const getAll = async (params: any) => {
  try {
    const config: ReturnType = {
      url: 'categories',
      method: 'get',
      params,
      config: {
        showErr: true,
        store: {
          action: 'set',
          key: 'bookCategories',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}

const create = async (data: any) => {
  try {
    const config: ReturnType = {
      url: 'categories',
      method: 'post',
      data,
      authorization: true,
      config: {
        showErr: true,
        successMsg: 'Book created successfully!',
        store: {
          action: 'prepend',
          key: 'bookCategories',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}
const update = async (data: any, id: number) => {
  try {
    const config: ReturnType = {
      url: `categories/${id}`,
      method: 'patch',
      data,
      authorization: true,
      config: {
        showErr: true,
        successMsg: 'Book created successfully!',
        store: {
          action: 'update',
          key: 'bookCategories',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}
const remove = async (id: any) => {
  try {
    const config: ReturnType = {
      url: `categories/${id}`,
      method: 'delete',
      authorization: true,

      config: {
        showErr: true,
        successMsg: 'Book deleted successfully!',
        store: {
          action: 'remove',
          key: 'bookCategories',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}

export default {
  remove,
  update,
  create,
  getAll,
}
